import React from "react";
import { ListGroup } from "components/bootstrap";
import ControlledTableListHeader from "./ControlledTableListHeader";
import ControlledTableListItem from "./ControlledTableListItem";
const ControlledTableList = ({ children }) => {
  let effectiveChildren;
  if (children.length === 0) {
    effectiveChildren = /* @__PURE__ */ React.createElement(ControlledTableListItem, null, "No items to display");
  } else {
    effectiveChildren = children;
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ListGroup, null, effectiveChildren));
};
ControlledTableList.Header = ControlledTableListHeader;
ControlledTableList.Item = ControlledTableListItem;
export default ControlledTableList;
